<div class="w-full h-full mx-auto">
  <div class="w-full h-full
              bg-secondary relative
              flex flex-col shadow
              gap-y-4 justify-center
              rounded-[1.563rem] p-6">
    <div class="bg-primary justify-center items-center h-[4.625rem] w-[4.625rem]
                -top-2 absolute flex -right-2  rounded-2xl p-1">
      <img src="assets/icons/clean-water.svg" [alt]="item?.header"/>
    </div>

    <div class="text-xl text-darker font-semibold">
      {{ item?.header }}
    </div>

    <div class="w-full text-gray">
      {{ item?.text }}
    </div>

    <div class="w-full flex flex-row justify-between items-center mt-auto flex-wrap">
      <button type="button"
              (click)="onOpenMail()"
              class="w-fit h-9
                     px-5 py-2 my-2
                     flex items-center
                     bg-primary rounded-full
                     text-lg font-semibold
                     whitespace-nowrap cursor-pointer
                     text-white ripple">
        Offerte nodig? Mail nu!
      </button>

<!--      <button type="button"-->
<!--              (click)="onRedirect(item)"-->
<!--              class="w-fit h-9-->
<!--                           px-5 py-2 my-2-->
<!--                           flex items-center-->
<!--                           bg-white rounded-full-->
<!--                           text-lg font-semibold-->
<!--                           text-primary-->
<!--                           border border-primary-->
<!--                           whitespace-nowrap cursor-pointer-->
<!--                           ripple ripple-white">-->
<!--        Meer info-->
<!--      </button>-->
    </div>
  </div>
</div>
